import { render } from "./ExhibitionInfoModal.vue?vue&type=template&id=86943028&scoped=true"
import script from "./ExhibitionInfoModal.vue?vue&type=script&lang=js"
export * from "./ExhibitionInfoModal.vue?vue&type=script&lang=js"

import "./ExhibitionInfoModal.vue?vue&type=style&index=0&id=86943028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86943028"]])

export default __exports__